import { VISUALISATION } from '~utils/types/VisualisationType'

const isQuantityVisualisation = (visualisationType) =>
  visualisationType === VISUALISATION.QUANTITY

export { isQuantityVisualisation }
